export default "__VITE_ASSET__9whO$jBw__"